import { useState } from 'react';
import transformAuthResponse from '../apiResponseTransformers/userAuth';
import { getApiUrl } from './constants';
import { useAppName } from '../../utils/sitecoreContext';
import { useGetUserAuthQuery } from '../apis/hondaRestApi';
var PRODUCT_LINES;
(function (PRODUCT_LINES) {
    PRODUCT_LINES["HONDA"] = "honda";
    PRODUCT_LINES["ACURA"] = "acura";
})(PRODUCT_LINES || (PRODUCT_LINES = {}));
const useUserAuth = (shouldFetch) => {
    const appName = useAppName();
    const url = getApiUrl(appName);
    const shouldSkip = !shouldFetch ||
        !url ||
        (appName.toLowerCase() !== PRODUCT_LINES.HONDA && appName.toLowerCase() !== PRODUCT_LINES.ACURA);
    return useGetUserAuthQuery({ url, skip: shouldSkip });
};
export function useFetchUserAuth() {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { refetch, data: userAuthData } = useUserAuth(true);
    const appName = useAppName();
    const url = getApiUrl(appName);
    async function fetchUserAuth() {
        if (!url)
            return null;
        setIsLoading(true);
        try {
            const response = await fetch(url, {
                method: 'get',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const res = await response.json();
                const transformedData = transformAuthResponse(res);
                setData(transformedData);
                setIsLoading(false);
                if ((userAuthData === null || userAuthData === void 0 ? void 0 : userAuthData.isUserLoggedIn) !== transformedData.isUserLoggedIn)
                    refetch();
                return transformedData;
            }
            setIsLoading(false);
            return null;
        }
        catch (e) {
            setIsLoading(false);
            // eslint-disable-next-line no-console
            console.error('failed to fetch user auth', e);
        }
        return null;
    }
    return { data, isLoading, fetchUserAuth };
}
export default useUserAuth;
